import React, { useEffect, useState } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { loadingSpace } from '../assets/styles';
import { convertDateFormat } from '../assets/scripts';

const columns = [
  { id: 'first_name', label: 'First Name' },
  { id: 'last_name', label: 'Last Name' },
  { id: 'email', label: 'Email', minWidth: 100 },
  { id: 'phone_no', label: 'Phone', minWidth: 100 },
  { id: 'subscribed_on', label: 'Subscribed On', minWidth: 100 },
  { id: 'subscribe_expired_on', label: 'Expiry Date', minWidth: 100 },
];

export default function StickyHeadTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [isSTLoading, setIsSTLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsSTLoading(true);
      try {
        const response = await fetch(`https://apivsfintech.invtechnologies.in/subscribersdata`);
        if (!response.ok) {
          throw new Error(`http error status:${response.status}`);
        }
        const result = await response.json();
        setRows(result.data.reverse());
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsSTLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        {
          isSTLoading ? <Box style={loadingSpace}><CircularProgress /> </Box> :
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {columns.map((column) => {
                          let value = row[column.id];
                          if(column.id === 'subscribed_on') {
                        value = convertDateFormat(value);
                      } else if(column.id === 'subscribe_expired_on') {
                        value = convertDateFormat(value);
                      } 
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format && typeof value === 'number'
                                ? column.format(value)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
        }
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
